import React, { Component } from "react";
import { View, Image, Text, TouchableOpacity } from "react-native";
import chatstyles from "../styles/chatStyles";
import VideoPlayer from "../commonComponents/VideoPlayer";

class AgentTransferring extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timer: null,
      counter: 60,
    };
  }
  // on load page.
  componentDidMount() {
    this.startTimer();
  }
  // to manage the counter
  manageTimer = () => {
    const { counter } = this.state;

    if (counter === 0) {
      // alert("Times Up !\nTimer will reset");
      this.setState({
        counter: 60,
      });
    } else {
      this.setState({
        counter: this.state.counter - 1,
      });
    }
  };

  // to start the counter
  startTimer = () => {
    let timer = setInterval(this.manageTimer, 1000);
    this.setState({ timer });
  };
  componentWillUnmount() {
    clearInterval(this.state.timer);
  }

  render() {
    const { isAgentConnected } = this.props;
    return (
      <View>
        {!isAgentConnected && (
          <View>
            <View style={chatstyles.agentTransfer}>
              <View style={chatstyles.agentImageView}>
                <Image
                  source={require("../../assets/images/operator.png")}
                  style={chatstyles.agentImage}
                />
              </View>
              <Text style={chatstyles.transferText}>
                Transferring you to a specialist in {this.state.counter} sec
              </Text>
            </View>
            <VideoPlayer url={this.props.url.advertisementUrl} />
          </View>
        )}
      </View>
    );
  }
}
export default AgentTransferring;
